import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getInProgressFieldWorks(companyId, query) {
  return dataTransferWrap(
    ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS,
    dtConfig[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS].getInProgressFieldWorks,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

export default {
  getInProgressFieldWorks,
}